import React, { Component } from "react";
import Loader from "react-loaders";
import { Redirect, Route } from "react-router";
import { AuthenticatedRoute, OroLoader, OroLoaderInline } from "./core";
import { middlewareService } from "./shared/service";
import AppShell from "./shell/components/AppShell";
import { Spinner } from "reactstrap";
import { getEncryptedPKey } from "./waitlist/services/waitlist-service";
import { utils } from "./core/helpers/utils";

export default class LoadingScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPageLoaded: false,
    };
  }

  componentDidMount() {
    let isRedirectionSet = localStorage.getItem("redirectionSet");
    let redirectedFrom = window.location.href.split("#");
    if (!isRedirectionSet) {
      localStorage.setItem("redirectionSet", true);
      localStorage.setItem("redirectedFrom", redirectedFrom[1]);
    }
    let params = window.location.hash.split("?");
    if (params.length > 1 && params[1] !== '') {
      window.localStorage.setItem('params', params[1]);
    }

    if (window.ReactNativeWebView) {
      const searchParams = new URLSearchParams(window.location.href.split("?")[1]);

      const payload = Array.from(searchParams.entries()).reduce(
        (obj, [key, val]) => {
          obj[key] = val;
          return obj;
        },
        {}
      );

      if (Object.keys(payload).length) {
        let action = "";

        if (payload.docId && payload.orderId) {
          action = "DIGIO_ESIGN";
        }

        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action,
            payload,
          })
        );
      }
    }

    if (String(process.env.REACT_APP_IS_PKEY) === "true") {
      getEncryptedPKey().then(() => {
        middlewareService.getApiData("/authStatus").then((result) => {
          const response = utils.parsePayload(result);
          if (response.email && response.state) {
            this.setState({
              isAuthenticated: true,
              isPageLoaded: true,
            });
          } else {
            this.setState({
              isAuthenticated: false,
              isPageLoaded: true,
            });
          }
        });
      })
    } else {
      middlewareService.getApiData("/authStatus").then((result) => {
        const response = utils.parsePayload(result);
        if (response.email && response.state) {
          this.setState({
            isAuthenticated: true,
            isPageLoaded: true,
          });
        } else {
          this.setState({
            isAuthenticated: false,
            isPageLoaded: true,
          });
        }
      });
    }
  }

  goToLocation = () => {
    const hash = window.location.hash;
    const queryParameters = new URLSearchParams(hash.split('?')[1]);
  
    if (queryParameters.has("action") && queryParameters.get("action") === "jump") {
      // Redirect to /login-jump
      window.location.href = "/login-jump";
    } else {
      // Redirect to /login
      window.location.href = "/login";
    }
  };
  
  

  render() {
    return (
      <React.Fragment>
        {!this.state.isPageLoaded ? (
          <div className="loadingScreen">
            <Spinner 
              style={{
                color: "#283A97"
              }}
            />
            {/* <OroLoader /> */}
          </div>
        ) : this.state.isAuthenticated ? (
          <Route path="/" component={AppShell} />
        ) : (
          this.goToLocation()
        )}
      </React.Fragment>
    );
  }
}
